import React from 'react';
import { Link } from 'gatsby';
import Logo from '../components/logo';

import Nav from '../components/nav';
import UtilityNav from '../components/utility-nav';
import SocialMedia from '../components/socialmedia';
import AnniversaryLogo from '../images/anniversary_logo';


import '../css/header.css';

function Header() {
  return (
    <React.Fragment>
      <div className="container headerContainer">
         <div className="headerLeft">
          <Link to="/">
            <Logo className="mainLogo" />
          </Link>
          </div>
          <div className="headerRight">
            <UtilityNav />

            <SocialMedia className="socialHeader" />
            <div class="nav-wrapper">
            <Nav />
            
            <form className="headerSearch" action="/search/">
              <input type="text" placeholder="Search Our Site..." name="q" />
              <button type="submit"><i className="far fa-search"></i></button>
            </form>
            </div>
          
        </div>
      </div>
    </React.Fragment>
  );
}
export default Header;